import CryptoJS from "crypto-js";
// const CryptoJS = require("crypto-js");
function encrypt(data, type, mode, keyt, ivt) {
  let encrypted = CryptoJS.enc.Utf8.parse(data);
  let key = CryptoJS.enc.Utf8.parse(keyt);
  let iv = CryptoJS.enc.Utf8.parse(ivt);
  if (mode === 'cbc' && type === 'aes' ) {
    encrypted = CryptoJS.AES.encrypt(encrypted, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  } else if (mode === 'ecb' &&  type === 'aes') {
    encrypted = CryptoJS.AES.encrypt(encrypted, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  } else if (mode === 'ecb' &&  type === 'des3') {
    encrypted = CryptoJS.TripleDES.encrypt(encrypted, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  } else if (mode === 'cbc' && type === 'des3') {
    encrypted = CryptoJS.TripleDES.encrypt(encrypted, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  } else if (mode === 'ecb' &&  type === 'des') {
    encrypted = CryptoJS.DES.encrypt(encrypted, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  } else if (mode === 'cbc' && type === 'des') {
    encrypted = CryptoJS.DES.encrypt(encrypted, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  }
  // 获取加密后的字节数和数组
  const encryptedBytes = encrypted.ciphertext.sigBytes;
  const encryptedArray = encrypted.ciphertext.clone().words;

  // 将字节数和数组结合起来，获取原始的二进制数据
  const encryptedData = new Uint8Array(encryptedBytes);
  for (let i = 0; i < encryptedBytes; i++) {
      encryptedData[i] = (encryptedArray[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
  }
  return encryptedData;
}

const BIT00 = "\u200c";
const BIT01 = "\u200d";
const BIT10 = "\u2060";
const BIT11 = "\u2062";
const BIT0101 = "\u2063";
const BIT0000 = "\u2064";

const UnHuffmanMap = {
    '\u200c': 0x00,
    '\u200d': 0x01,
    '\u2060': 0x02,
    '\u2062': 0x03,
};

export function getKey(){
  const encryptedData = data;
  return encryptedData;
}
export function encryptionData(data, k, type){
  // 加密数据
  switch(type){
    case 1:
      return encrypt(data, 'des', 'cbc', k.slice(0, 8), k.slice(8, 16));
    case 2:
      return encrypt(data, 'des3', 'cbc', k.slice(0, 24), k.slice(24));
    case 3:
      return encrypt(data, 'aes', 'ecb', k.slice(0, 16), null);
    case 4:
      return encrypt(data, 'des', 'ecb', k.slice(0, 8), null);
    case 5:
      return encrypt(data, 'des3', 'ecb', k.slice(0, 24), null);
    default:
      return encrypt(data, 'aes', 'cbc', k.slice(0, 16), k.slice(16));
    }
}
/**
 * 等宽隐藏字符转换
 * @param {*} inStr 
 * @returns 
 */
export function UnHuffman(inStr) {
    inStr = inStr.replace(new RegExp(BIT0101, "g"), BIT01 + BIT01);
    inStr = inStr.replace(new RegExp(BIT0000, "g"), BIT00 + BIT00);

    let b = [];
    let pos = 0;
    let temp = 0;
    for (let i of inStr) {
        if (UnHuffmanMap[i] != undefined) {
            temp |= UnHuffmanMap[i] << pos;
            pos += 2;
            if (pos == 8) {
                b.push(temp);
                pos = 0;
                temp = 0;
            }
        } else {
            return new Error("invalid huffman code");
        }
    }
    return String.fromCharCode(...b);
}

export function MD532Lower(data) {
  // 计算 MD5 哈希值
  const md5Hash = CryptoJS.MD5(data).toString(CryptoJS.enc.Hex);
  // 将 MD5 哈希值转换为 32 位小写字符串
  const md5HashLowerCase = md5Hash.toLowerCase();
  return md5HashLowerCase;
}